import { render, staticRenderFns } from "./key-unit.vue?vue&type=template&id=72eb5c64&scoped=true"
import script from "./key-unit.vue?vue&type=script&lang=js"
export * from "./key-unit.vue?vue&type=script&lang=js"
import style0 from "./key-unit.vue?vue&type=style&index=0&id=72eb5c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eb5c64",
  null
  
)

export default component.exports